const ru_RU = {
  "产品菜单": "Продукты",
  "关于我们菜单": "О нас",
  "帮助中心菜单": "Центр помощи",
  "信用基础": "Кредит как основа",
  "加密支付": "Криптоплатежи",
  "全币种支持": "Поддержка всех валют",
  "全节点承兑": "Поддержка всех узлов",
  "去中心担保": "Децентрализованная гарантия",
  "立即开始使用": "Начать сейчас",
  "闪电般的支付体验": "Молниеносные платежи",
  "完成跨境支付": "Межграничный платеж за 45 секунд",
  "多链支持": "Мультичейн поддержка",
  "支持主流公链资产": "Поддержка основных публичных блокчейнов",
  "实时结算": "Расчет в реальном времени",
  "无需等待": "Мгновенное зачисление, без ожидания",
  "超额担保": "Сверхобеспечение",
  "资金安全有保障": "Безопасность средств гарантирована",
  "一个钱包": "Один кошелек",
  "所有可能": "Все возможности",
  "商户收款": "Прием платежей для бизнеса",
  "全球化支付网关": "Глобальный платежный шлюз",
  "承兑服务": "Сервис поддержки",
  "稳定可靠的承兑网络": "Стабильная и надежная сеть поддержки",
  "数字资产": "Цифровые активы",
  "多链资产管理": "Управление мультичейн активами",
  "下载": "Загрузить приложение",
  "多节点承兑": "Многоузловая поддержка",
  "全币种支持": "Поддержка всех валют",
  "去中心担保": "Децентрализованная гарантия",
  "生态": "Экосистема NECO",
  "钱包": "TEPAY Wallet",
  "立即下载": "Скачать сейчас",
  "随时汇币": "Платите криптовалютой в любое время и в любом месте",
  "一个钱包": "Один кошелек",
  "走天下": "для всего мира",
  "海量订单": "Огромное количество заказов",
  "日进斗金": "Зарабатывайте каждый день",
  "首页描述": "TePay — это децентрализованная кредитно-платежная инфраструктура, а не банк. Финансовые услуги поддерживаются нашей сетью принимающих узлов и сетью смарт-контрактов на блокчейне. Механизмы залога и кредита обеспечивают безопасные и соответствующие транзакции, а хранение средств и разрешение споров управляются через нашу систему арбитража DAO. Мультичейн-взаимодействие и интегрированные модули соответствия предоставляют бесшовный и прозрачный платежный опыт как для пользователей, так и для продавцов.",
  "轻松交易": "Легкие сделки",
  "slide2Text": "Свободный и беспрепятственный обмен фиатных и цифровых валют через децентрализованную многоузловую сеть TePay",
  "slide2Info": "TePay — это децентрализованная платежная платформа, а не традиционный банк. Услуги предоставляются нашей сетью многоузловой поддержки и обеспечиваются блокчейн-смарт-контрактами. Механизмы избыточного залога и кредитного скоринга гарантируют, что каждая транзакция соответствует требованиям и безопасна.",
  "全球通用": "Глобально",
  "让每一笔支付": "Чтобы каждый платеж",
  "瞬间达成": "мгновенно выполнялся",
  "slide3Text": "Свободно торгуйте фиатными и цифровыми валютами в мощной сети TePay.",
  "slide3Info": "TePay не ограничивается одной валютой. Наша децентрализованная платформа позволяет вам легко отправлять, получать и обменивать различные валюты, стирая границы и обеспечивая единообразный опыт. Благодаря технологии блокчейн и динамическим кредитным механизмам ваши средства всегда в безопасности и работают эффективно.",
  "护航每笔交易": "Сопровождаем каждую сделку",
  "去中心化担保": "Децентрализованная гарантия",
  "安全无忧": "Безопасность и спокойствие",
  "slide4Text": "Обеспечьте доверие и безопасность для каждой транзакции через механизм децентрализованной гарантии.",
  "slide4Info": "TePay — это не традиционный банк, а безопасность транзакций, обеспечиваемая механизмом децентрализованной гарантии. Наша система использует избыточное обеспечение, динамический кредитный скоринг и арбитраж DAO для надежного обеспечения каждой транзакции. Этот мощный механизм гарантии эффективно соединяет традиционные финансы с цифровыми активами, гарантируя, что все платежи соответствуют требованиям, безопасны и эффективны.",
  "一个钱包走天下": "Один кошелек для всего мира",
  "币随时付": "Платите криптой в любое время",
  "跨境无忧": "Межграничные платежи без забот",
  "slide5Text": "Управляйте всеми вашими активами, как фиатными, так и цифровыми, в одном безопасном кошельке.",
  "slide5Info": "TePay объединяет ваш финансовый мир, решая все платежные потребности с помощью одного кошелька. Наша платформа объединяет управление активами и глобальные транзакции, используя передовые технологии блокчейн и динамические кредитные механизмы, чтобы предоставить вам беспрепятственный и эффективный финансовый опыт.",
  "海量订单": "Огромное количество заказов",
  "海量订单: 日进斗金": "Зарабатывайте каждый день",
  "slide6Text": "Охватите потребности продавцов и клиентов в различных валютах для неограниченной прибыли.",
  "slide6Info": "Наш динамический механизм сопоставления стирает барьеры между фиатными и цифровыми валютами, позволяя узлам поддержки получать прибыль, независимо от того, какую валюту используют продавцы или клиенты. Платформа обеспечивает эффективные расчеты, увеличивая ваш доход с каждой транзакцией.",
  "边兑边赚": "Зарабатывайте на обмене",
  "信用随行": "Кредит всегда с вами",
  "slide7Text": "Каждый обмен увеличивает ваш доход и повышает вашу кредитоспособность.",
  "slide7Info": "TePay — это не традиционный банк, а безопасность транзакций, обеспечиваемая механизмом децентрализованной гарантии. Наша система использует избыточное обеспечение, динамический кредитный скоринг и арбитраж DAO для надежного обеспечения каждой транзакции. Этот мощный механизм гарантии эффективно соединяет традиционные финансы с цифровыми активами, гарантируя, что все платежи соответствуют требованиям, безопасны и эффективны.",
  "下载TEPAY": "Скачать TEPAY",
  "开启信用支付": "Начать кредитные платежи",
  "多币种支持": "Поддержка мульти-валют",
  "多节点承兑描述": "Многоузловая поддержка",
  "下载Text": "Скачать",
  "链上赋能": "Блокчейн-усиленная Социальная Коммерция",
  "品牌即社区": "Бренд — это сообщество",
  "消费即投资": "Потребление — это инвестиция",
  "本地即全球": "Локальное — это глобальное",
  "首页描述": "NECO (来客), платформа социальной коммерции, построена на основе децентрализованной веб3-структуры доверия. Она глубоко интегрирует реальное потребление с прозрачными блокчейн-кэшбэками, переосмысливая цикл создания ценности для пользователей, продавцов и сообществ, создавая новую парадигму совместной, доверенной и устойчивой коммерции.",
  "真实消费": "Реальное потребление",
  "支撑返利": "обеспечивает кэшбэк",
  "slide2Text": "Чем больше покупаете, тем реальнее возврат",
  "slide2Info": "NECO генерирует соответствующие бонды и баллы только после подтверждения выполнения заказа в блокчейне; размер кэшбэка строго привязан к 20% скидке от продавца, без какого-либо превышения эмиссии. Это означает, что все вознаграждения платформы оплачиваются реальными денежными потоками, и каждый NECO/USAI, который видит пользователь, можно отследить в обозревателе блоков, полностью исключая риски «финансовых пирамид».",
  "透明积分": "Прозрачные баллы",
  "代币经济": "Токеномика",
  "slide3Text": "Баллы в блокчейне, ценность можно проверить",
  "slide3Info1": "Кэшбэк от потребления разделен на две учетные записи: токен платформы NECO и стейблкоин USAI:",
  "slide3Info2": "Первый линейно высвобождается на 0.2% ежедневно, второй автоматически балансирует курс при сжигании/эмиссии.",
  "slide3Info3": "Все события эмиссии, сжигания и высвобождения записываются смарт-контрактами, любой может в реальном времени проверить баланс кошелька, отсчет времени до высвобождения и историю транзакций, предоставляя каждому поощрению открытый «идентификатор».",
  "多角色": "Мульти-ролевая",
  "激励生态": "стимулирующая экосистема",
  "slide4Text1": "Пользователи, лидеры групп, продавцы — выигрывают все",
  "slide4Info1": "Пользователи: 100% возврат баллов за покупки, держите NECO для получения прибыли и прав управления;",
  "slide4Info2": "Лидеры групп: организуйте групповые покупки, управляйте сообществами, получайте комиссию + дополнительные награды NECO;",
  "slide4Info3": "Продавцы: предоставляйте скидки для точных заказов, пользуйтесь расчетами с 0 комиссией и экспозицией бренда.",
  "slide4Info4": "Доходы всех трех сторон записываются в одну блокчейн-формулу, доходы и усилия сверяются в реальном времени, создавая самоподдерживающийся цикл вирусного роста.",
  "合规保障": "Соответствие и гарантии",
  "全程可审": "Полная проверяемость",
  "slide5Text": "След в блокчейне, дружелюбно к регуляторам",
  "slide5Info1": "Шлюз TePay отвечает за KYC, взаимодействие с фиатом и соответствие платежей; данные о транзакциях, размер скидки, распределение баллов — все хранится в блокчейне.",
  "slide5Info2": "Платформа также включает двойной оракул, ценовой буфер и фонд управления рисками DAO. В случае экстремальных рыночных условий или изменений в политике, голосование управления может активировать ограничения скорости, выкуп или механизмы приостановки — обеспечивая спокойствие регуляторов, пользователей и долголетие экосистемы.",
  "合作伙伴": "Партнеры",
  "社区团购": "Групповые покупки в сообществе",
  "社区小店": "Местные магазины",
  "社区空间": "Общественные пространства",
  "社区服务": "Общественные услуги",
  "NECO优选": "NECO Премиум",
  "暂未开放": "Скоро откроется",
  "新闻标题": "Новостной центр",
  "新闻1标题": "Объявление о запуске Genesis, выпуске приложения и открытии системы членства",
  "新闻1内容": "Уважаемые члены сообщества:\n\nМы планируем открыть торговые пары NECO/nUSDT и USAI/nUSDT на Novai SWAP 5 августа в 24:00 (GMT+8), завершив первичный запуск токена платформы и стейблкоина.\n\nОдновременно приложение NECO официально откроет регистрацию и запустит глобальную систему членства, где вы сможете выполнить следующие действия:\n1. Регистрация пользователя и обмен реферальными ссылками.\n2. Пополнение предоплатного счета USDT для конвертации в USAI и покупка VIP-членства.\n3. Высвобождение баллов для узлов Genesis и обычных узлов (получение дохода в NECO).\n4. Получение реферальных вознаграждений за членство и командные бонусы, управление своей командой.\n5. Высвобождение баллов за покупки (от покупки членства, командных и узловых вознаграждений) в NECO.\n6. Мгновенный обмен NECO на USAI и вывод средств (текущая версия поддерживает вывод в USDT).\n7. Базовая функция кэшбэка акциями (просмотр цены NECO, просмотр торговой пары NECO на SWAP, просмотр объявлений и т.д.).\n\nВ случае изменения сроков мы сообщим дополнительно.",
  "返回": "Назад",
  "消费返股": "Кэшбэк акциями Социальная Коммерция",
  "全球首个": "Первая в мире",
  "WEB3社区电商平台": "Веб3 Платформа Социальной Коммерции",
  "消费": "Потребляйте",
  "赚钱": "Зарабатывайте",
  "持股": "Владейте",
  "合伙人": "Партнер",
  "用户": "Пользователь",
  "股东": "Акционер",
  "不只是电商": "NECO — это не просто коммерция",
  "更是社区电商": "Это социальная коммерция",
  "共赢闭环": "Пользователи, лидеры групп, продавцы — выигрывают все",
  "用户描述": "Пользователи: 100% возврат баллов за покупки, держите NECO для получения прибыли и прав управления;",
  "团长描述": "Лидеры групп: организуйте групповые покупки, управляйте сообществами, получайте комиссию + дополнительные награды NECO;",
  "商户描述": "Продавцы: предоставляйте скидки для точных заказов, пользуйтесь расчетами с 0 комиссией и экспозицией бренда.",
  "三方描述": "Доходы всех трех сторон записываются в одну блокчейн-формулу, доходы и усилия сверяются в реальном времени, создавая самоподдерживающийся цикл вирусного роста.",
  "购物聊天": "NECO AI коммерция: покупки так же просты, как чат",
  "边聊边选": "Общайтесь и выбирайте одновременно",
  "聊天助手实时理解你的对话": "AI-помощник в чате понимает ваш диалог в реальном времени,",
  "就能找到你要的东西": "одна фраза — и вы найдете то, что нужно.",
  "AI优选": "AI Подбор",
  "的那一刻": "В тот момент, когда вы открываете NECO,",
  "已经在等你": "самые подходящие товары и услуги уже ждут вас.",
  "时尚分身": "Стильный цифровой двойник",
  "监控价格": "Ищет для вас товары, отслеживает цены,",
  "守护你的消费体验": "оберегает ваш покупательский опыт.",
  "三类团购机制": "Три механизма групповых покупок",
  "附近团": "Районная группа",
  "熟人团": "Группа знакомств",
  "优选团": "Премиум группа",
  "全球战略布局": "Глобальная стратегическая экспансия",
  "使命与愿景": "Миссия и видение NECO",
  "使命": "Миссия",
  "愿景": "Видение",
  "使命描述": "Создание справедливой, прозрачной и доступной для участия самоорганизующейся коммерческой системы",
  "愿景描述": "Зажечь огонь сообщественной экономики в каждом уголке мира",
  "公告": "Объявления",
  "铸造销毁协议": "Протокол эмиссии и сжигания",
  "SWAP交易": "SWAP Торговля",
  "NECO社区电商": "NECO Социальная Коммерция",
  "菜单": "Меню",
  "安卓下载": "Скачать для Android",
  "ios下载": "Скачать для iOS",
  "NECO下载": "Скачать приложение NECO",
  "支持版本": "Поддерживаемые версии IOS и Android",
  "当前版本": "Текущая версия",
  "跨链桥": "Мост",
  "合作伙伴关系": "Партнерские отношения",
  "请加入社交媒体信息": "Пожалуйста, присоединяйтесь к информации в социальных сетях",
  "联系我们": "Свяжитесь с нами",
  "版权所有（公司）": "Авторское право (компания)",
  "联系我们的邮件请填写": "Свяжитесь с нашей почтой, пожалуйста, заполнить",
  "新闻": "Новости",
  "网页直连": "Прямая ссылка на страницу",
  "铸造与销毁协议": "Протокол литья и уничтожения",
  "更多": "больше",
  "请通过": "Пожалуйста, пройдите",
  "与我们联系": "Связаться с нами",
  "版权所有": "Авторское право",
  "联系": "связь",
  "智能体": "Чат - бот",

  
  "全球首个": "Первый в мире",
  "WEB3社区电商平台": "Платформа сообщества электронной коммерции WEB3",
  "消费": "Потребление",
  "持股": "Владение акциями",
  "升值": "Рост стоимости",
  "重新定义消费的价值": "Переосмысление ценности потребления",
  "让消费成为财富的起点": "Сделать потребление отправной точкой богатства",
  "消费即拥有，分享即收益": "Потребляйте, чтобы владеть, делитесь, чтобы получать прибыль",
  "NECO 是一套基于 Web3 技术的智能电商基础设施，通过「消费即持股」机制，让每一位用户在购物时获得真实权益与长期回报。 在这里，消费者不只是用户，更是平台的拥有者和生态的建设者。": "NECO - это интеллектуальная инфраструктура электронной коммерции на основе технологии Web3. Благодаря механизму «потребление равно владению акциями», каждый пользователь может получить реальные права и долгосрочную отдачу при совершении покупок. Здесь потребители - это не просто пользователи, а владельцы платформы и строители экосистемы.",
  "核心技术": "Основные технологии",
  "基于 Novai Chain 的二层网络": "Двухуровневая сеть на основе Novai Chain",
  "Neco Chain 是构建在 Novai Chain 之上的高性能二层网络，": "Neco Chain - это высокопроизводительная двухуровневая сеть, построенная поверх Novai Chain,",
  "专为高频电商与支付结算设计，平均出块时间仅 0.2 秒，TPS 超过 50,000。": "специально разработанная для высокочастотной электронной коммерции и расчетов, со средним временем формирования блока всего 0,2 секунды и TPS свыше 50 000.",
  "Neco Chain 将电商的每笔消费行为与激励记录上链，": "Neco Chain записывает каждое потребительское поведение и стимулирующие записи электронной коммерции в блокчейн,",
  "让商业行为具备长期可验证性与可追溯性。": "обеспечивая долгосрочную проверяемость и прослеживаемость коммерческой деятельности.",
  "高速并行账本结构": "Высокоскоростная параллельная структура книги учета",
  "智能结算与动态费用调节": "Интеллектуальные расчеты и динамическая регулировка комиссий",
  "消费凭证 NFT 化与积分资产化": "Токенизация потребительских ваучеров в NFT и активизация баллов",
  "核心特性": "Основные характеристики",
  "链上结算": "Расчеты в блокчейне",
  "每笔电商交易 0.2 秒确认，安全透明": "Каждая транзакция электронной коммерции подтверждается за 0,2 секунды, безопасно и прозрачно",
  "激励协议": "Протокол стимулирования",
  "激励消费者、商家、渠道等为NECO做出贡献": "Стимулирование потребителей, продавцов, каналов и других участников вносить вклад в NECO",
  "权益积分": "Баллы прав и интересов",
  "用户消费即持有可追踪、可变现的权益积分": "Пользователи владеют отслеживаемыми и конвертируемыми баллами прав и интересов через потребление",
  "共建共享": "Совместное строительство и совместное использование",
  "首个去中心商业自治组织，共建共享NECO电商": "Первая децентрализованная организация коммерческого самоуправления, совместное строительство и использование электронной коммерции NECO",
  "主要产品": "Основные продукты",
  "支持电商 RWA 的高性能公链": "Высокопроизводительный публичный блокчейн с поддержкой RWA электронной коммерции",
  "稳定币、DEX、去中心信用等电商基础协议": "Основные протоколы электронной коммерции: стейблкоины, DEX, децентрализованный кредит и т.д.",
  "同时为WEB2和WEB3用户服务的电商APP": "Приложение электронной коммерции, обслуживающее как пользователей WEB2, так и WEB3",
  "法币和数字货币统一支付及结算体系": "Единая система оплаты и расчетов фиатных и цифровых валют",
  "竞争优势": "Конкурентные преимущества",
  "极速公链": "Сверхбыстрый публичный блокчейн",
  "0.2 秒出块，支持百万级并发订单及支付交易。": "Формирование блоков за 0,2 секунды, поддержка миллионных параллельных заказов и платежных транзакций.",
  "全球合规": "Глобальное соответствие требованиям",
  "在全球各地通过 DAO 组织进行本地合规运营。": "Локальная операционная деятельность в соответствии с требованиями через организации DAO по всему миру.",
  "电商 RWA": "Электронная коммерция RWA",
  "第一个将现实世界电商完全放在链上运行的平台。": "Первая платформа, полностью запускающая реальную электронную коммерцию в блокчейне.",
  "商业闭环": "Замкнутый бизнес-цикл",
  "让消费、社交与收益形成价值闭环。": "Создание замкнутого цикла ценности между потреблением, социальными сетями и доходами.",
  "全球分销体系让每个用户都能成为品牌的传播者与收益方。": "Глобальная система дистрибуции позволяет каждому пользователю стать распространителем бренда и выгодополучателем.",
  "消费者端": "Сторона потребителя",
  "注册/消费即得积分奖励，积分每日释放为资产。": "Регистрация/потребление дает награду в виде баллов, баллы ежедневно преобразуются в активы.",
  "商家端": "Сторона продавца",
  "一键接入结算 API，设置折让比例与积分政策。": "Подключение к API расчетов в один клик, установка процента скидки и политики баллов.",
  "分销端": "Сторона дистрибуции",
  "允许全球用户参与分销，共享收益与品牌成长。": "Разрешение глобальным пользователям участвовать в дистрибуции, совместное использование доходов и роста бренда.",
  "NECO 生态系统": "Экосистема NECO",
  "一个融合金融、科技与商业的去中心化生态。": "Децентрализованная экосистема, объединяющая финансы, технологии и бизнес.",
  "Neco Chain 公链": "Публичный блокчейн Neco Chain",
  "商业级高速 Layer 2 网络（Novai L2），提供结算与数据验证基础设施。": "Высокоскоростная сеть второго уровня коммерческого класса (Novai L2), обеспечивающая инфраструктуру расчетов и верификации данных.",
  "NECO App": "Приложение NECO",
  "用户购物、签到、邀请与分销的统一入口。": "Единый вход для покупок пользователей, регистрации, приглашений и дистрибуции.",
  "USAI 稳定币": "Стейблкоин USAI",
  "用于平台内支付与结算的稳定币资产，锚定美元价值。": "Актив стейблкоина, используемый для оплаты и расчетов внутри платформы, привязанный к долларовой стоимости.",
  "U Card 全球消费卡": "Глобальная потребительская карта U Card",
  "连接线上线下消费场景，支持积分抵扣与现金返还。": "Связывает онлайн и офлайн потребительские сценарии, поддерживает списание баллов и возврат наличных.",
  "NECO AI 智能系统": "Интеллектуальная система NECO AI",
  "通过 AI 分析用户行为，实现个性化推荐与安全风控。": "Анализ поведения пользователей с помощью ИИ для достижения персонализированных рекомендаций и контроля безопасности.",
  "消费金融该协议": "Протокол потребительских финансов",
  "提供通用的去中心化金融基础设施，支持电商资产流通。": "Обеспечение универсальной децентрализованной финансовой инфраструктуры для поддержки обращения активов электронной коммерции.",
  "稳定币生态": "Экосистема стейблкоинов",
  "构建覆盖支付、结算与跨境流通的稳定币网络。": "Создание сети стейблкоинов, охватывающей оплату, расчеты и трансграничное обращение.",
  "团队及投资人": "Команда и инвесторы",
  "全球化视野 · 多元化背景。": "Глобальный взгляд · Многообразие опыта.",
  "NECO 团队成员来自新加坡、中国、阿联酋等地，拥有电商、金融科技与区块链技术领域超过十年的行业经验。": "Члены команды NECO прибыли из Сингапура, Китая, ОАЭ и других регионов, обладают более чем десятилетним опытом в области электронной коммерции, финтеха и технологий блокчейна.",
  "投资人": "Инвесторы",
  "运营团队": "Операционная команда",
  "Moe Farmani": "Moe Farmani",
  "拥有多年欧洲、中东、南美零售企业创业经验,曾创建迪拜领先的数字货币交易所 加密货币的重度信仰者": "Имеет многолетний опыт предпринимательства в европейских, ближневосточных и южноамериканских розничных компаниях. Создал ведущую биржу цифровых валют в Дубае. Является ярым сторонником криптовалют",
  "Matt Romman": "Matt Romman",
  "从事迪拜房地产和零售行业多年。拥有丰富的跨国公司管理经验。": "Многолетняя работа в сфере недвижимости и розничной торговли в Дубае. Обладает богатым опытом управления транснациональными корпорациями.",
  "Alex Eric": "Alex Eric",
  "曾任职OKX，负责公司品牌和战略": "Работал в OKX, отвечал за бренд компании и стратегию",
  "Manoharlal": "Manoharlal",
  "Novai Chain Founder， 全面支撑NECO技术落地。": "Основатель Novai Chain, всесторонняя поддержка реализации технологий NECO.",
  "官方路线图": "Официальная дорожная карта",
  "2025 — 创世与启动": "2025 - Генезис и запуск",
  "2025 — 增长与市场拓展": "2025 - Рост и расширение рынка",
  "2026 — 生态深化与 AI 赋能": "2026 - Углубление экосистемы и внедрение ИИ",
  "上半年（Q2–Q3）": "Первое полугодие (Q2-Q3)",
  "完成白皮书、制度模型与产品原型开发": "Завершение разработки белой книги, институциональной модели и прототипа продукта",
  "组织九大社区进行创世启动": "Организация девяти крупных сообществ для генезисного запуска",
  "完成 300 个节点招募，发行 NECO & USAI 代币，添加初始流动性池": "Завершение набора 300 узлов, выпуск токенов NECO & USAI, добавление начального пула ликвидности",
  "发布 NECO APP BETA 测试版": "Выпуск тестовой версии BETA приложения NECO",
  "下半年（Q3–Q4）": "Второе полугодие (Q3-Q4)",
  "全球社区运营中心部署完成": "Развертывание глобального центра эксплуатации сообщества завершено",
  "NECO 优选店铺与创世商户上线": "Выход в онлайн премиальных магазинов NECO и первых продавцов",
  "推动注册用户突破 10 万": "Продвижение числа зарегистрированных пользователей свыше 100 тыс.",
  "启动空投及全球电商启动大会": "Запуск эирдропа и глобальной конференции по запуску электронной коммерции",
  "Q4：好货推广 & 本地电商": "Q4: Продвижение хороших товаров и местная электронная коммерция",
  "上线「好货系统」并开放会员商家入驻": "Запуск системы «хороших товаров» и открытие регистрации для продавцов-участников",
  "在主要国家开通 TePay 法币支付": "Включение оплаты фиатом TePay в основных странах",
  "完成中国、韩国、越南 10 家 NECO Best 本地电商落地": "Завершение запуска 10 местных электронных коммерций NECO Best в Китае, Корее и Вьетнаме",
  "海外注册用户突破 50 万，VIP 用户突破 5 万": "Зарубежные зарегистрированные пользователи превысили 500 тыс., VIP-пользователи превысили 50 тыс.",
  "举办第二次社区电商大会，开放跨境卖家注册": "Проведение второй конференции сообщества электронной коммерции, открытие регистрации трансграничных продавцов",
  "拓展中东、南美、非洲与欧洲本地市场，整合供应链": "Расширение местных рынков на Ближнем Востоке, в Южной Америке, Африке и Европе, интеграция цепочки поставок",
  "注册用户突破 100 万，VIP 用户突破 10 万": "Зарегистрированные пользователи превысили 1 млн, VIP-пользователи превысили 100 тыс.",
  "Q1–Q2：体系完善": "Q1-Q2: Совершенствование системы",
  "跨境卖家突破 10 万，商家数量超 10 万": "Трансграничные продавцы превысили 100 тыс., количество продавцов свыше 100 тыс.",
  "举办第一届 NECO 电商生态大会": "Проведение первой конференции экосистемы электронной коммерции NECO",
  "上线稳定币生态与信用体系": "Запуск экосистемы стейблкоинов и кредитной системы",
  "注册用户突破 500 万，VIP 超过 20 万": "Зарегистрированные пользователи превысили 5 млн, VIP свыше 200 тыс.",
  "Q3–Q4：智能升级": "Q3-Q4: Интеллектуальное обновление",
  "获得主要国家支付牌照，全面上线法币支付服务": "Получение лицензий на оплату в основных странах, полный запуск сервиса оплаты фиатом",
  "上线 AI 选品与推荐功能": "Запуск функции выбора товаров и рекомендаций с помощью ИИ",
  "商家信用、积分全面上链": "Кредит продавцов и баллы полностью переведены в блокчейн",
  "NECO Best 优选商家突破 100 家": "Премиальные продавцы NECO Best превысили 100",
  "注册用户突破 1000 万，VIP 超过 50 万": "Зарегистрированные пользователи превысили 10 млн, VIP свыше 500 тыс.",
  "加入 NECO": "Присоединяйтесь к NECO",
  "消费创造财富，社区共建共享。": "Потребление создает богатство, сообщество совместно строит и делится.",
  "一分钟带你了解NECO": "Одна минута познакомит вас с NECO",
  "NECO 通过链上透明的返利机制，让每一次消费都能获得真实收益。": " NECO обеспечивает реальную выгоду от каждого потребления с помощью прозрачного механизма возврата прибыли в цепочке. ",
  "相比传统电商，NECO 的利润由智能合约按比例即时返还，0 抽佣、0 压货。": "По сравнению с традиционными электронными торговцами, прибыль NECO мгновенно возвращается пропорционально смарт - контрактами, 0 домработниц, 0 товаров под давлением.",
  "用户与商家共享增长红利。": "Пользователи делятся дивидендами роста с коммерсантами",
  "全球版": "Глобальная версия",
  "中国版": "Версия для Китая",

}
export default ru_RU



// WEBPACK FOOTER //
// ./src/i18n/config/ru_RU.js